import { Input, Label } from '@iwoca/orion';
import { useLingui } from '@lingui/react/macro';
import { useFormContext } from 'react-hook-form';

import styles from './NameScreen.module.css';
import { TMobileSignupForm, TPersonTitleDE } from '../../form/form';
import { OptionCards, TOption } from '../../OptionCards/OptionCards';
import { StepLayout } from '../../StepLayout/StepLayout';

// DIT-686. Salutation + first / last name. Reads/writes the shared mobile
// signup form store (DIT-664).
export const NameScreen = () => {
  const { t } = useLingui();
  const { register, watch, setValue } = useFormContext<TMobileSignupForm>();

  const title = watch('title');
  const firstName = watch('firstName');
  const lastName = watch('lastName');
  const isValid = Boolean(title && firstName.trim() && lastName.trim());

  const titles: TOption<TPersonTitleDE>[] = [
    { value: 'herr', label: t`Man` },
    { value: 'frau', label: t`Woman` },
  ];

  return (
    <StepLayout
      stageTitle={t`Tell us about yourself`}
      heading={t`What is your name?`}
      ctaDisabled={!isValid}
    >
      <div className={styles.fields}>
        <div className={styles.field}>
          <Label>{t`Title`}</Label>
          <OptionCards
            name="title"
            options={titles}
            value={title}
            onChange={(value) =>
              setValue('title', value, { shouldDirty: true })
            }
            columns={2}
            hideRadio
          />
        </div>
        <Input {...register('firstName')} label={t`First name`} />
        <Input {...register('lastName')} label={t`Last name`} />
      </div>
    </StepLayout>
  );
};
